import userReducer from './userReducer'
import bookingReducer from './bookingReducer'
import dxReducer from './dxReducer'

const rootReducer = {
  userReducer,
  bookingReducer,
  dxReducer,
};

export default rootReducer
